import { OauthPage, SignInPage } from '@pages/public/auth';
import { InvitePage } from '@pages/public/auth/invite/ui/invite';
import { Routes } from '@shared/constants/routes';
import { AuthLayout } from '@shared/layouts';
import { type RouteObject } from 'react-router-dom';

export const publicRoutes: RouteObject[] = [
  {
    element: <AuthLayout />,
    children: [
      {
        path: Routes.authentication.signIn,
        element: <SignInPage />,
      },
      {
        path: Routes.authentication.oauthYandex,
        element: <OauthPage authType="yandex" />,
      },
      {
        path: Routes.authentication.oauthGoogle,
        element: <OauthPage authType="google" />,
      },
      {
        path: Routes.authentication.invite,
        element: <InvitePage />,
      },
    ],
  },
];
